import React, { useState } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { getFormattedNumber, hasPermission } from "utility/helpers";
import { StyledEditIcon } from "assets/js/Styles";
import styled from "styled-components";
import BudgetComponent from "../budget";
import StackedProgressBar from "../stacked-progress-bar";

const Wrapper = styled.div``;

const TotalBudgetSection = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
`;

const TotalBudgetContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TotalBudgetItems = styled.div`
  display: flex;
  flex-direction: row;
`;

const EndorsementText = styled.h5`
  font-weight: bold;
`;

const TotalBudgetText = styled.h6`
  font-weight: bold;
`;

const ProgressBarSection = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

const AmountText = styled.h6`
  font-weight: bold;
  margin-left: 0.25rem;
`;

const EndorsementsAndBudget = ({
  newTotalBudget,
  totalBudget,
  totalAmountSpent,
  projects,
  remainingBalance,
  handleOverallBudgetChange,
}) => {
  const [isBudgetEditing, setIsBudgetEditing] = useState(false);

  const toggle = () => setIsBudgetEditing(!isBudgetEditing);

  return (
    <Wrapper>
      <TotalBudgetContainer>
        <EndorsementText>{"Endorsements"}</EndorsementText>

        <div>
          <TotalBudgetSection>
            <TotalBudgetItems>
              {!isBudgetEditing && hasPermission("project-update") && (
                <>
                  <StyledEditIcon
                    size={16}
                    onClick={() => toggle()}
                    id="edit-budget-icon"
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target="edit-budget-icon"
                  >
                    {"Edit Budget"}
                  </UncontrolledTooltip>
                </>
              )}

              <h6>{"Total Budget"}</h6>
            </TotalBudgetItems>
            <TotalBudgetText>{getFormattedNumber(totalBudget)}</TotalBudgetText>
          </TotalBudgetSection>
          <BudgetComponent
            value={totalBudget || 0}
            newValue={newTotalBudget}
            isOpen={isBudgetEditing}
            handleToggle={toggle}
            totalAmountSpent={totalAmountSpent}
            handleOnChange={handleOverallBudgetChange}
          />
        </div>
      </TotalBudgetContainer>

      <ProgressBarSection>
        <StackedProgressBar data={projects} />
      </ProgressBarSection>

      <TotalBudgetItems>
        <h6>{"Amount Spent:"}</h6>
        <AmountText>{getFormattedNumber(totalAmountSpent)}</AmountText>
      </TotalBudgetItems>

      <TotalBudgetItems>
        <h6>{"Remaining Balance:"}</h6>
        <AmountText>{getFormattedNumber(remainingBalance)}</AmountText>
      </TotalBudgetItems>
    </Wrapper>
  );
};

export default EndorsementsAndBudget;
